import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import EarningRulesTab from "@/components/EarningRulesTab";

export default function VendorEarningRulesPage() {
  const { user } = useAuth();
  const vid = user?.vendor_id;
  return (
    <div className="space-y-5 max-w-5xl" data-testid="vendor-earning-rules-page">
      <div>
        <h1 className="text-2xl font-bold text-ink tracking-tight">Earning Rules</h1>
        <p className="text-sm text-ink/40 mt-0.5">
          Create bonus point &amp; stamp rules — happy hours, double-point days, item boosts and more.
          Rules apply automatically on top of your base reward system at checkout.
        </p>
      </div>
      {vid ? <EarningRulesTab vendorId={vid} /> : null}
    </div>
  );
}
